export const DOCUMENT_PREVIEW_STATUS_PENDING = "PENDING";
export const DOCUMENT_PREVIEW_STATUS_PROCESSING = "PROCESSING";
export const DOCUMENT_PREVIEW_STATUS_READY = "READY";
export const DOCUMENT_PREVIEW_STATUS_FAILED = "FAILED";

export type DocumentPreviewStatus =
  | typeof DOCUMENT_PREVIEW_STATUS_PENDING
  | typeof DOCUMENT_PREVIEW_STATUS_PROCESSING
  | typeof DOCUMENT_PREVIEW_STATUS_READY
  | typeof DOCUMENT_PREVIEW_STATUS_FAILED;

export const GENERATING_PREVIEW_STATUSES: ReadonlySet<DocumentPreviewStatus> =
  new Set([
    DOCUMENT_PREVIEW_STATUS_PENDING,
    DOCUMENT_PREVIEW_STATUS_PROCESSING,
  ]);

export const WORD_PREVIEW_POLL_INTERVAL_MS = 3000;
export const WORD_PREVIEW_POLL_TIMEOUT_MS = 3 * 60 * 1000;
export const CHAT_WORD_RENDER_TIMEOUT_MS = 20 * 1000;
